import { render, staticRenderFns } from "./TotalProduct.vue?vue&type=template&id=2cb4cc1d"
import script from "./TotalProduct.vue?vue&type=script&lang=js"
export * from "./TotalProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports